<template>
    <div>
        <!-- 所有的人 -->
        <el-form :inline="true" :model="form" @keyup.enter.prevent="loadData">
            <el-form-item>
                <el-input v-model="form.keyword" placeholder="请输入关键字" @keyup.enter.native="loadData"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="loadData">搜索</el-button>
            </el-form-item>
        </el-form>
        <div>
            <el-table :data="tableData" v-loading="loading" @selection-change="handleSelectionChange" :row-key="getRowKeys">
                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.pageSize===10"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column type="selection" width="55" :reserve-selection="moreSelect" ></el-table-column>
                <el-table-column label="用户名" prop="internalUserid"></el-table-column>
                <el-table-column label="工号" prop="employeeNo"></el-table-column>
                <el-table-column label="真实姓名" prop="name"></el-table-column>
                <el-table-column label="邮箱" prop="email"></el-table-column>
                <el-table-column label="部门" prop="department.name"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <div style="margin:70px 0 10px 0;display: flex;">
            <el-button type="primary" size="small" @click="submit" :disabled="submitBtn">确定</el-button>
            <el-button type="default" size="small" @click="onCancel">取消</el-button>
        </div>
    </div>
</template>

<script>
    import services from "../../services/common.service"
    export default {
        props:{
            tit:{
                type:String,
                default:"请选择请求人"
            },
            id:String,
            callback:Function,
            moreSelect:{//是否可以选择多个人
                type:Boolean,
                default:false
            },
            enable:{
                type:Boolean,
                default:false
            }
        },
        data() {
            return {
                tableData:[],
                loading:true,
                form:{
                    pageIndex:1,
                    pageSize:10,
                    keyword:""
                },
                multipleSelection: [],
                total:null,
                submitBtn:true
            }
        },
        created() {
            this.$modal.title = this.tit;
            if(this.enable){
                this.form['enable'] = true
            }
            this.request();
        },
        methods: {
            loadData(){
                this.form.pageIndex=1
                this.request()
            },
            request(){
                services.getAllUser(this.form).then(res => {
                    this.tableData = res.list;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            getRowKeys(row){
                return row.id
            },
            // 选择请求人
            handleSelectionChange(val){
                if(val.length > 1 && !this.moreSelect){
                    this.submitBtn = true;
                    this.$message.error("只可选择一个请求人");
                }else{
                    this.multipleSelection = val;
                    this.submitBtn = false;
                }
            },
            submit(){
                if(this.multipleSelection.length == 0){
                    this.$message.error("请至少选择一个请求人")
                }else{
                    if(this.moreSelect){
                        this.callback(this.multipleSelection);
                    }else{
                        this.callback(this.multipleSelection[0]);
                    }
                    // this.multipleSelection = []
                    this.$modal.close();
                }
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },

            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
